import { isNil } from 'lodash';

export function notNil<T>(value: T | null | undefined): value is T {
  return !isNil(value);
}

// TODO: combine usage of this and notNil
export function isNotNil<T>(value: T | null | undefined): value is T {
  return !isNil(value);
}
